
import { Client, ProductPriceKey, ICalculatedProductPrice, GetPricesQueryArgs } from "Api/CoreApi";
import { ACombineApiCalls } from "Api/Helpers/ACombineApiCalls";
import ApiProvider from "./ApiProvider";


export default class PriceApi extends ACombineApiCalls<ProductPriceKey, ICalculatedProductPrice> {
   

    private constructor() {
        super();
    }
    
    private static _instance = new PriceApi();
    public static getInstance() {
        return this._instance;
    }

    async call(keys: ProductPriceKey[]): Promise<ICalculatedProductPrice[]> {
        let client = ApiProvider.getApiClient();
        let prices = await client.getPrices(new GetPricesQueryArgs({ keys: keys }));
        return prices.prices;
    }

    matches(key: ProductPriceKey, result: ICalculatedProductPrice): boolean {
        if (key.productId !== result.productId) return false;
        if (key.unitOfMeasure !== result.unitOfMeasure) return false;
        if (key.variantId !== result.variantId) return false;
        for (let extraInfoKey in key.extraInfo) {
            if (key.extraInfo[extraInfoKey] !== result.extraInfo[extraInfoKey]) return false;
        }
        return true;
    }


}